<div class="plain-footer">
  <ul>
    <li class="link-container">
      <a
        *ngIf="!isLandingPage; else imprintDialog"
        routerLink="/home/imprint"
        routerLinkActive="active-link"
        attr.aria-label="{{ 'label.imprint' | translate }}"
      >
        <i *ngIf="isHandset$ | async" class="bi bi-buildings-fill"></i>
        <span *ngIf="(isHandset$ | async) === false">{{
          'label.imprint' | translate
        }}</span>
      </a>
      <ng-template #imprintDialog>
        <a
          (click)="openDialog('imprint')"
          attr.aria-label="{{
            'label.imprint' | translate
          }}"
        >
          <i *ngIf="isHandset$ | async" class="bi bi-house-fill"></i>
          <span *ngIf="(isHandset$ | async) === false">{{
            'label.imprint' | translate
          }}</span>
        </a>
      </ng-template>
    </li>
    <li class="link-container" *ngIf="tenant === 'default'">
      <a
        *ngIf="!isLandingPage; else termsOfServiceDialog"
        routerLink="/home/terms-of-service"
        routerLinkActive="active-link"
        attr.aria-label="{{
          'label.terms-of-service-short' | translate
        }}"
      >
        <i *ngIf="isHandset$ | async" class="bi bi-book-half"></i>
        <span *ngIf="(isHandset$ | async) === false">{{
          'label.terms-of-service-short' | translate
        }}</span>
      </a>
      <ng-template #termsOfServiceDialog>
        <a
          (click)="openDialog('terms-of-service')"
          attr.aria-label="{{
            'label.terms-of-service-short' | translate
          }}"
        >
          <i *ngIf="isHandset$ | async" class="bi bi-book-half"></i>
          <span *ngIf="(isHandset$ | async) === false">{{
            'label.terms-of-service-short' | translate
          }}</span></a
        >
      </ng-template>
    </li>
    <li class="link-container">
      <a
        *ngIf="!isLandingPage; else privacyTermsDialog"
        routerLink="/home/privacy-terms"
        routerLinkActive="active-link"
        attr.aria-label="{{
          'label.privacy-terms' | translate
        }}"
      >
        <i *ngIf="isHandset$ | async" class="bi bi-shield-lock-fill"></i>
        <span *ngIf="(isHandset$ | async) === false">{{
          'label.privacy-terms' | translate
        }}</span>
      </a>
      <ng-template #privacyTermsDialog>
        <a
          (click)="openDialog('privacy-terms')"
          attr.aria-label="{{
            'label.privacy-terms' | translate
          }}"
        >
          <i *ngIf="isHandset$ | async" class="bi bi-shield-lock-fill"></i>
          <span *ngIf="(isHandset$ | async) === false">{{
            'label.privacy-terms' | translate
          }}</span></a
        >
      </ng-template>
    </li>
    <li class="link-container">
      <a
        *ngIf="!isLandingPage; else systemRequirements"
        routerLink="/home/system-requirements"
        routerLinkActive="active-link"
        attr.aria-label="{{
          'label.system-requirements' | translate
        }}"
      >
        <i *ngIf="isHandset$ | async" class="bi bi-laptop-fill"></i>
        <span *ngIf="(isHandset$ | async) === false">{{
          'label.system-requirements' | translate
        }}</span>
      </a>
      <ng-template #systemRequirements>
        <a
          (click)="openDialog('system-requirements')"
          attr.aria-label="{{
            'label.system-requirements' | translate
          }}"
        >
          <i *ngIf="isHandset$ | async" class="bi bi-laptop-fill"></i>
          <span *ngIf="(isHandset$ | async) === false">{{
            'label.system-requirements' | translate
          }}</span></a
        >
      </ng-template>
    </li>
    <li class="link-container">
      <ng-container [ngSwitch]="tenant">
        <a
          *ngSwitchCase="'default'"
          href="{{ linkToContactPage }}"
          attr.aria-label="{{
            'label.contact' | translate
          }}"
          target="contact-page"
          rel="noopener noreferrer"
        >
          <i *ngIf="isHandset$ | async" class="bi bi-envelope-at-fill"></i>
          <span *ngIf="(isHandset$ | async) === false">{{
            'label.contact' | translate
          }}</span>
        </a>
        <ng-container *ngSwitchCase="'sdv'">
          <a
            *ngIf="!isLandingPage; else contactSdv"
            routerLink="/home/contact"
            routerLinkActive="active-link"
            attr.aria-label="{{
              'label.contact' | translate
            }}"
          >
            <i *ngIf="isHandset$ | async" class="bi bi-envelope-at-fill"></i>
            <span *ngIf="(isHandset$ | async) === false">{{
              'label.contact' | translate
            }}</span>
          </a>
          <ng-template #contactSdv>
            <a
              (click)="openDialog('contact-sdv')"
              attr.aria-label="{{
                'label.contact' | translate
              }}"
            >
              <i *ngIf="isHandset$ | async" class="bi bi-envelope-at-fill"></i>
              <span
                *ngIf="(isHandset$ | async) === false"
                >{{ 'label.contact' | translate }}</span
              ></a
            >
          </ng-template>
        </ng-container>
      </ng-container>
    </li>
    <li class="link-container" *ngIf="tenant === 'default'">
      <a
        class="withdrawal-link"
        href="{{ linkToWithdrawalPage }}"
        attr.aria-label="{{
          'label.declare-withdrawal' | translate
        }}"
        target="withdrawal-page"
        rel="noopener noreferrer"
      >
        <i *ngIf="isHandset$ | async" class="bi bi-arrow-counterclockwise"></i>
        <span *ngIf="(isHandset$ | async) === false">{{
          'label.declare-withdrawal' | translate
        }}</span>
      </a>
    </li>
  </ul>
  <div
    class="link-container"
    [ngClass]="{
      copyright: (isHandset$ | async) === false,
      'copyright-mobile': isHandset$ | async
    }"
    [tooltip]="'Backend: ' + backendVersion + ', Frontend: ' + versionFrontend"
    [tooltipClass]="'tooltip'"
  >
    © <span>{{ yearNow }}</span> ITB Consulting
  </div>
</div>
